import DescriptionIcon from '@mui/icons-material/Description';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMTextBox } from '../../ui-elements/MyMTextBox';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import ValidatableRadio from '../../ui-parts/ValidatableRadio';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';

/** MyMine Version2.1 RequestInfo画面新規追加
* RequestInfo Page Component
*/
export const RequestInfo = (props) => {

  const { requestSequenceNo, handleModalClose } = props;
  const screenId = 'MyM706';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const maxTextLength = screenSettings?.MaxTextLength;
  const [isLoading, setIsLoading] = useState(false);
  const [requestItem, setRequestItem] = useState(null);
  const validationRules = useValidationRules();
  const [selectedAnswerStatusValue, setSelectedAnswerStatusValue] = useState(null);
  const [resultValue, setResultValue] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const [isEnableAnswer, setIsEnableAnswer] = useState(false);
  const [updateComplete, setUpdateComplete] = useState(false);
  const navigate = useNavigate();
  const { handleSubmit, control, formState } = useForm({
    mode: 'onSubmit',
  })
  const { authUser } = useContext(AuthUserContext);
  const isPc = useMediaQuery(mediaQuery.pc);

  // ページロード時処理
  useEffect(() => {
    setUpdateComplete(false);
    const callbackSuccess = (result) => {
      setRequestItem(result);
      setSelectedAnswerStatusValue(result.AnswerStatus);
      setResultValue(result.Result);
      // Adminユーザ 又は ContentsOwner 且つ Sales担当者のみ回答可能
      setIsEnableAnswer(
        (authUser.RoleId === constants.UserRole.Administrators ||
          (authUser.RoleId === constants.UserRole.Uploaders && authUser.ContentIdList.some(contentId => contentId === constants.ContentType.Sales))))
      setIsLoading(false);
    }

    const callbackFailed = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson(`api/request/info-load?requestSequenceNo=${requestSequenceNo}`, 'GET', callbackSuccess, callbackFailed)
    setIsLoading(true);
  }, [updateComplete]);

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsPreviewModalOpen(true);
  }

  const handleStatusChange = (e) => {
    setSelectedAnswerStatusValue(e);
  };

  const handleResultChange = (value) => {
    setResultValue(value);
  };

  /** ModalCloseイベント */
  const handlePreviewModalClose = () => setIsPreviewModalOpen(false);

  const onclickUpdateButton = () => {
    if (window.confirm(messageList.MyM_MSG_I_0001)) {
      const param = {
        AnswerStatus: selectedAnswerStatusValue,
        Result: resultValue,
        RequestSequenceNo: requestSequenceNo
      };

      const callbackUpdateSuccess = () => {
        window.alert(messageList.MyM_MSG_I_0002);
        setIsLoading(false);
        setUpdateComplete(true);
      }

      const callbackFailed = () => setIsLoading(false);

      apiRequest.requestJson('api/request/info-update', 'POST', callbackUpdateSuccess, callbackFailed, param);
      setIsLoading(true);
    }
  }

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  if (requestItem === null)
    return <MyMProgress />

  return (
    <Box sx={{ height: "100%", overflowY: "auto", padding: '10px' }}>
      {isLoading && <MyMProgress />}
      <Grid container>
        <Grid container item xs={12} sx={{ padding: isPc ? '5px' : '0px' }}>
          <Grid item xs={isPc ? 1.5 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <MyMLabel>{controlSettings.LabelList.lblTitleName}</MyMLabel>
          </Grid>
          <Grid item xs={isPc ? 10.5 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <MyMTextBox fullWidth disabled={true} inputValue={requestItem.RequestTitle} />
          </Grid>
        </Grid>
        {/**/}
        <Grid container item xs={12} sx={{ padding: isPc ? '5px' : '0px' }}>
          <Grid container item xs={isPc ? 6 : 12}>
            <Grid item xs={isPc ? 3 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMLabel>{controlSettings.LabelList.lblUserNameTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 9 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox width={isPc ? '95%' : '100%'} disabled={true} inputValue={requestItem.Name} />
            </Grid>
          </Grid>
          <Grid container item xs={isPc ? 3.6 : 12}>
            <Grid item xs={isPc ? 6.7 : 12} sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'end', xs: 'start' }, paddingRight: '10px' }}>
              <MyMLabel>{controlSettings.LabelList.lblPostdateTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 5.3 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox width={isPc ? '95%' : '100%'} disabled={true} inputValue={utility.formatDate(requestItem.RegistrationDate, 'yyyy/MM/dd')} />
            </Grid>
          </Grid>
          <Grid container item xs={isPc ? 2.4 : 12} sx={{ display: 'flex' }} >
            <Grid item xs={isPc ? 4 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMLabel>{controlSettings.LabelList.lblDeadlineTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 8 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox fullWidth disabled={true} inputValue={utility.formatDate(requestItem.DeadlineDate, 'yyyy/MM/dd')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} sx={{ padding: isPc ? '5px' : '0px' }}>
          <Grid container item xs={isPc ? 6 : 12}>
            <Grid item xs={isPc ? 3 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMLabel>{controlSettings.LabelList.lblEmailTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 9 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox width={isPc ? '95%' : '100%'} disabled={true} inputValue={requestItem.Email} />
            </Grid>
          </Grid>
          <Grid container item xs={isPc ? 6 : 12}>
            <Grid item xs={isPc ? 4 : 12} sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'end', xs: 'start' }, paddingRight: '10px' }}>
              <MyMLabel>{controlSettings.LabelList.lblCompanyTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 8 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox fullWidth disabled={true} inputValue={requestItem.CompanyName} />
            </Grid>
          </Grid>
        </Grid>
        {/**/}
        <Grid container item xs={12} sx={{ padding: isPc ? '5px' : '0px' }}>
          <Grid container item xs={isPc ? 6 : 12}>
            <Grid item xs={isPc ? 3 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMLabel>{controlSettings.LabelList.lblRequestCategoryTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 9 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
              <MyMTextBox width={isPc ? '95%' : '100%'} disabled={true} inputValue={requestItem.RequestCategoryName} />
            </Grid>
          </Grid>
          <Grid container item xs={isPc ? 6 : 12}>
            <Grid item xs={isPc ? 4 : 12} sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'end', xs: 'start' }, paddingRight: '10px' }}>
              <MyMLabel>{controlSettings.LabelList.lblProductCategoryTitle}</MyMLabel>
            </Grid>
            <Grid item xs={isPc ? 8 : 12}>
              <MyMTextBox fullWidth disabled={true} inputValue={requestItem.TargetProductCategoryName} />
            </Grid>
          </Grid>
        </Grid>
        {/**/}
        <Grid container item xs={12} sx={{ padding: isPc ? '5px' : '0px' }}>
          <Grid item xs={isPc ? 1.5 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <MyMLabel>{controlSettings.LabelList.lblTargetProductTitle}</MyMLabel>
          </Grid>
          <Grid item xs={isPc ? 10.5 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <MyMTextBox fullWidth disabled={true} inputValue={requestItem.TargetProductName} />
          </Grid>
        </Grid>
        {/**/}
        <Grid container item xs={12} sx={{ padding: '5px' }}>
          <Grid item xs={isPc ? 10 : 4} sx={{ display: 'flex', alignItems: 'end' }}>
            <MyMLabel>{controlSettings.LabelList.lblDetailTitle}</MyMLabel>
          </Grid>
          <Grid item xs={isPc ? 2 : 8} sx={{ paddingTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
            {requestItem.RequestFileList.length !== 0 &&
              requestItem.RequestFileList.map((item) => (
                <MyMTooltip title={item.Value} key={item.Key}>
                  <DescriptionIcon style={{ cursor: 'pointer', fontSize: '50px' }} onClick={(e) => { onClickPreview(e, item.Key) }} key={item.Key} />
                </MyMTooltip>
              ))
            }
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MyMTextBox
            multiline
            rows={16}
            fullWidth
            height='400px'
            disabled={true}
            inputValue={requestItem.RequestContent}
          />
        </Grid>
        {/**/}
        <Grid item xs={12}>
          <Grid sx={{ borderTop: '2px solid black', margin: '10px 0' }} />
        </Grid>
        {/**/}
        <Grid container item xs={12}>
          <Grid item xs={isPc ? 8 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <MyMLabel>{controlSettings.LabelList.lblEventsTitle}</MyMLabel>
          </Grid>
          <Grid item xs={isPc ? 4 : 12} sx={{ display: 'flex', alignItems: 'center' }}>
            <ValidatableRadio
              name="status"
              control={control}
              row={true}
              radioList={requestItem.RequestAnswerStatusList}
              formState={formState}
              radioProps={{ disabled: !isEnableAnswer }}
              onChange={(e) => handleStatusChange(e.target.value)}
              checkValue={selectedAnswerStatusValue}
            />
          </Grid>
          <Grid item xs={12} sx={{ width: '100%' }}>
            <Box sx={{ position: 'relative', width: '100%' }}>
              <ValidatableTextBox
                control={control}
                name="txtEventsInput"
                value={resultValue ?? ''}
                formState={formState}
                multiline={true}
                rows={4}
                sx={{ width: '100%' }}
                onChange={(e) => handleResultChange(e.target.value)}
                disabled={!isEnableAnswer}
                maxLength={maxTextLength}
                rules={{
                  ...validationRules.maxLength(maxTextLength)
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                  mt: 0.5
                }}
              >
                <Typography variant="caption">
                  {resultValue?.length ?? 0} / {screenSettings.MaxTextLength}
                </Typography>
              </Box>
            </Box>
            <Grid container sx={{ paddingTop: '5px' }}>
              <Grid item>
                <MyMLabel>{controlSettings.LabelList.lblLatestUpdateTitle}</MyMLabel>
              </Grid>
              <Grid item>
                <MyMLabel>{utility.formatDateTime(requestItem.UpdatedDate, 'yyyy/MM/dd HH:mm:ss')}</MyMLabel>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
        <Grid container spacing={3} sx={{ padding: isPc ? '0px 40px 0px 0px' : '25px 0px 0px 0px', justifyContent: "flex-end" }}>
          <Grid item>
            {isEnableAnswer &&
              <MyMButton onClick={handleSubmit(onclickUpdateButton, onError)}>{controlSettings.LabelList.btnUpdate}</MyMButton>}
          </Grid>
          <Grid item>
            <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnClose}</MyMButton>
          </Grid>
        </Grid>
      </Grid>
      {isPreviewModalOpen && <MyMModal
        open={isPreviewModalOpen}
        onClose={handlePreviewModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handlePreviewModalClose} />
      </MyMModal>}
    </Box>
  );
}